import React from 'react';
import MainPage from "./index";

const FiveDPage = (props) =>  <MainPage type={5} {...props}/>;
export default FiveDPage;
